import React,{useState} from 'react';
import CardDropdown from '@/components/common/CardDropdown';
import Flex from '@/components/common/Flex';
import { Card, Col, Row,Tab,Nav } from 'react-bootstrap';
import SOVCircleChart from './SOVCircleChart';
import FalconCardFooterLink from '@/components/common/FalconCardFooterLink';
import classNames from 'classnames';
import FalconCardHeader from '@/components/common/FalconCardHeader';


const NavItem = ({ item }) => {
    return (
      <Nav.Item as="li">
        <Nav.Link
          className="mb-0 py-3 cursor-pointer"
          eventKey={item.toLowerCase()}
        >
          {item}
        </Nav.Link>
      </Nav.Item>
    );
  };
  

const LeadItem = ({ item, isLast }) => {
  return (
    <Flex
      justifyContent="between"
      alignItems="center"
      className={classNames('border-bottom py-3', {
        'border-bottom-0 pb-0': isLast
      })}
    >
      <Flex>
        {/* <img src={item.img} alt="..." width={16} height={16} className="me-2" /> */}
        <h6 className="text-700 mb-0">{item.title}</h6>
      </Flex>
      <p className="fs-10 text-500 mb-0 fw-semibold">{item.target}</p>
      <h6 className="text-700 mb-0">{item.amount}%</h6>
    </Flex>
  );
};

const MostLeads = () => {
  const [navItems] = useState(['Revenue', 'Users', 'Deals', 'Profit']);

  const leadsData = [
    {
      id: 1,
      title: 'Email',
      target: '5200 vs 1052',
      img: '',
      amount: 12
    },
    {
      id: 2,
      title: 'Social',
      target: '5623 vs 4929',
      img: '',
      amount: 25
    },
    {
      id: 3,
      title: 'Call',
      target: '2535 vs 1486',
      img: '',
      amount: 63
    },
    {
      id: 4,
      title: 'Other',
      target: '256 vs 189',
      img: '',
      amount: 53
    }
  ];

  return (
    <Card>
      <Tab.Container id="audience-tab" defaultActiveKey="users">
        <Card.Header
          as={Flex}
          justifyContent="between"
          alignItems="center"
          className="ps-0 py-0 border-bottom"
        >
          <Nav
            as="ul"
            className="nav-tabs border-0 flex-nowrap chart-tab tab-active-caret"
          >
            {navItems.map(item => (
              <NavItem item={item} key={item} />
            ))}
          </Nav>
          <CardDropdown />
        </Card.Header>

        <Card.Body>
          <Row className="g-1">
            <Tab.Content>
              <Tab.Pane unmountOnExit eventKey="revenue">
                <Col md={5} xxl={12} className="mb-xxl-1">
                  <SOVCircleChart />
                </Col>
                <Col xxl={12} md={7}>
                  <hr className="mx-ncard mb-0 d-md-none d-xxl-block" />
                  {leadsData.map((item, index) => (
                    <LeadItem
                      key={item.id}
                      item={item}
                      isLast={index === leadsData.length - 1}
                    />
                  ))}
                </Col>
              </Tab.Pane>
              <Tab.Pane unmountOnExit eventKey="users">
                <Col md={5} xxl={12} className="mb-xxl-1">
                  <SOVCircleChart />
                </Col>
                <Col xxl={12} md={7}>
                  <hr className="mx-ncard mb-0 d-md-none d-xxl-block" />
                  {leadsData.map((item, index) => (
                    <LeadItem
                      key={item.id}
                      item={item}
                      isLast={index === leadsData.length - 1}
                    />
                  ))}
                </Col>
              </Tab.Pane>
              <Tab.Pane unmountOnExit eventKey="deals">
                <Col md={5} xxl={12} className="mb-xxl-1">
                  <SOVCircleChart />
                </Col>
                <Col xxl={12} md={7}>
                  <hr className="mx-ncard mb-0 d-md-none d-xxl-block" />
                  {leadsData.map((item, index) => (
                    <LeadItem
                      key={item.id}
                      item={item}
                      isLast={index === leadsData.length - 1}
                    />
                  ))}
                </Col>
              </Tab.Pane>
              <Tab.Pane unmountOnExit eventKey="profit">
                <Col md={5} xxl={12} className="mb-xxl-1">
                  <SOVCircleChart />
                </Col>
                <Col xxl={12} md={7}>
                  <hr className="mx-ncard mb-0 d-md-none d-xxl-block" />
                  {leadsData.map((item, index) => (
                    <LeadItem
                      key={item.id}
                      item={item}
                      isLast={index === leadsData.length - 1}
                    />
                  ))}
                </Col>
              </Tab.Pane>
            </Tab.Content>
          </Row>
        </Card.Body>
      </Tab.Container>
    </Card>
  );
};

export default MostLeads;
